import React from 'react'
import '../../../App.css'
import LeadershipLinks from '../LeadershipLinks';
import ImageComponent from '../../ImageComponent';

function WillSanderson() {
    return (
      <div className='bio-pages main-grid-container'>
      <div className='main-grid-item'>
    <LeadershipLinks/>
    </div>
          <div className='main narrow-grid'>
             <div className='bio-img-wrapper'>
              <ImageComponent src={require('../../../img/will_sanderson_bio_portrait_1000px.jpg')}/>
               {/* <img src={require('../../../img/will_sanderson_bio_portrait_1000px.jpg')} alt='larry loden portrait' /> */}
             </div>
            <h1 className='bio-header'>Will Sanderson</h1>
            {/* <h2 className='bio-subheader'>Student Ministry</h2> */}
            <p> 
            Will Sanderson was born and raised in Akron, OH. 
            After receiving a degree in Mass Communication at Union College in Barbourville, KY, Will studied at the Master’s Seminary where he worked at Grace Community Church and graduated with a Master’s of Divinity. 
            Following seminary training, Will moved to Lubbock, TX and served as an Associate Pastor at First Baptist Church Roosevelt. 
            He then moved to Phoenix to serve in a church where he met his wife Dempsey. 
            They have been married since June of 2024 and moved to Georgetown to serve at Grace Community Fellowship in September of that same year.
            </p>
          </div>
        </div>
      )
    }

export default WillSanderson
